/** Shape of a PAN: five letters, four digits, a letter (e.g. AAKPS1234Q). */
const PAN_FORMAT = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

/** The fourth letter of a PAN says who holds it. */
const HOLDERS: Readonly<Record<string, string>> = {
  P: 'Individual',
  C: 'Company',
  H: 'Hindu undivided family',
  F: 'Firm or LLP',
  A: 'Association of persons',
  T: 'Trust',
  B: 'Body of individuals',
  L: 'Local authority',
  J: 'Artificial juridical person',
  G: 'Government',
};

export function normalisePan(raw: string): string {
  return String(raw ?? '')
    .toUpperCase()
    .replace(/[\s-]/g, '');
}

export type PanCheck =
  | { ok: true; pan: string; holder: string }
  | { ok: false; pan: string; problem: 'empty' | 'length' | 'format' | 'holder' };

/** Check a PAN's shape and holder letter offline (PANs have no check digit to verify). */
export function checkPan(raw: string): PanCheck {
  const pan = normalisePan(raw);
  if (!pan) return { ok: false, pan, problem: 'empty' };
  if (pan.length !== 10) return { ok: false, pan, problem: 'length' };
  if (!PAN_FORMAT.test(pan)) return { ok: false, pan, problem: 'format' };
  const holder = HOLDERS[pan.charAt(3)];
  if (!holder) return { ok: false, pan, problem: 'holder' };
  return { ok: true, pan, holder };
}
